import { AxiosInstance } from "axios";
import { createLogger } from "logging";
import { VoteModel } from "models/VoteModel";

const logger = createLogger("VotingApi");

export class VotingApi {
  constructor(private axios: AxiosInstance) {}

  async getVotes(type: string, skip: number, pageSize: number): Promise<VoteModel[]> {
    try {
      const response = await this.axios.get<VoteModel[]>(`/votes/${type}/skip=${skip}&pageSize=${pageSize}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to fetch votes", error);
      throw error;
    }
  }

  async getVoteCount(type: string): Promise<number> {
    try {
      const response = await this.axios.get<number>(`/votes/${type}/count`);
      return response.data;
    } catch (error) {
      logger.error("Failed to fetch vote count", error);
      throw error;
    }
  }

  async sendVote(runTopicId: string, answer: number | null, userId: string): Promise<void> {
    try {
      await this.axios.post(`/votes/${runTopicId}/vote`, { answer, userId });
    } catch (error) {
      logger.error("Failed to send vote", error);
      throw error;
    }
  }

  async sendComment(runTopicId: string, comment: string, userId: string): Promise<void> {
    try {
      await this.axios.post(`/votes/${runTopicId}/comment`, { comment, userId });
    } catch (error) {
      logger.error("Failed to send comment", error);
      throw error;
    }
  }
}
